import React from "react";
import {
  Home,
  Layers,
  Warehouse,
  Armchair,
  Laptop,
  Flower2,
  Tv,
  Cpu,
  Sofa,
  IndianRupee,
  Lightbulb,
  Package,
  Users,
  Sparkles,
} from "lucide-react";
import AnimatedSection from "../common/AnimatedSection";
import SectionHeading from "../common/SectionHeading";

const section1Items = [
  { icon: Warehouse, label: "Complete Storage Solution – From Kitchen to Wardrobe" },
  { icon: Layers, label: "Wall Designing" },
  { icon: Layers, label: "False Ceiling" },
  { icon: Armchair, label: "Beds, Sofas & Consoles" },
  { icon: Laptop, label: "Study / Office Furnitures" },
  { icon: Flower2, label: "Balcony Makeovers" },
  { icon: Tv, label: "Home Appliances" },
  { icon: Cpu, label: "Home Automation" },
  { icon: Sofa, label: "Furnishings" },
];

const section2Items = [
  { icon: IndianRupee, label: "Budget Friendly Storage Solutions" },
  { icon: Lightbulb, label: "Extra Storage Ideas" },
  { icon: Package, label: "Rental-friendly packages starting at ₹3 Lakhs (ready in 20 days)" },
  { icon: Users, label: "500+ Residential Homes" },
  { icon: Sparkles, label: "Design Accents - Indian Regional Specific to Modern Homes" },
];

export default function HomeownersSection() {
  return (
    <section className="section-spacing bg-background-main">
      <div className="container-custom section-padding">
        <SectionHeading
          label="Solutions"
          title="For Homeowners"
          align="center"
        />

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 mt-16">
          {/* Section 1: Complete Storage Solution */}
          <AnimatedSection delay={200}>
            <div className="bg-white rounded-3xl p-8 lg:p-10 shadow-soft h-full">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-brand-primary rounded-2xl flex items-center justify-center">
                  <Home className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-heading text-2xl text-brand-primary">
                  Complete Storage Solution
                </h3>
              </div>
              
              <div className="space-y-4">
                {section1Items.map((item, index) => {
                  const IconComponent = item.icon;
                  return (
                    <div
                      key={index}
                      className="flex items-start gap-4 p-4 rounded-xl hover:bg-background-card transition-colors"
                    >
                      <div className="flex-shrink-0 w-10 h-10 bg-brand-accent/10 rounded-xl flex items-center justify-center">
                        <IconComponent className="w-5 h-5 text-brand-accent" />
                      </div>
                      <p className="text-text-primary font-medium pt-2">
                        {item.label}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </AnimatedSection>

          {/* Section 2: Budget Friendly Solutions */}
          <AnimatedSection delay={400}>
            <div className="bg-gradient-brand rounded-3xl p-8 lg:p-10 shadow-soft h-full">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center">
                  <IndianRupee className="w-6 h-6 text-white" />
                </div>
                <h3 className="font-heading text-2xl text-white">
                  Budget Friendly Solutions
                </h3>
              </div>
              
              <div className="space-y-4">
                {section2Items.map((item, index) => {
                  const IconComponent = item.icon;
                  return (
                    <div
                      key={index}
                      className="flex items-start gap-4 p-4 rounded-xl hover:bg-white/10 transition-colors"
                    >
                      <div className="flex-shrink-0 w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center">
                        <IconComponent className="w-5 h-5 text-white" />
                      </div>
                      <p className="text-white font-medium pt-2 leading-relaxed">
                        {item.label}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
}
